import './assets/sass/main.scss'
import Vue from 'vue'
import App from '@/App.vue'

import store from '@/store' 
import router from '@/router'

Vue.config.productionTip = false

// buefy
import Buefy from 'buefy'
// import 'buefy/dist/buefy.css'
Vue.use(Buefy)

// vuescrollto
const VueScrollTo = require('vue-scrollto')

Vue.use(VueScrollTo, {
  container: "body",
  duration: 0, // disabled for now
  easing: "ease",
  offset: -70, // navbar height
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

// for google analytics
// https://matteo-gabriele.gitbook.io/vue-gtag/v/master/auto-tracking
import VueGtag from "vue-gtag"

Vue.use(VueGtag, {
  config: { 
    id: "UA-19264928-1",
  },
}, router);

import VueSimpleMarkdown from 'vue-simple-markdown'
// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import 'vue-simple-markdown/dist/vue-simple-markdown.css'
Vue.use(VueSimpleMarkdown)

import vueVimeoPlayer from 'vue-vimeo-player' 
Vue.use(vueVimeoPlayer)

// did I disable this?
// Vue.use(VueRouter)

// Components
import GalleryThumb from './components/GalleryThumb.vue'
Vue.component('gallery-thumb', GalleryThumb)

import SpreadThumb from './components/SpreadThumb.vue'
Vue.component('spread-thumb', SpreadThumb)

import PostMedia from './components/PostMedia.vue'
Vue.component('post-media', PostMedia)

import VueScrollReveal from 'vue-scroll-reveal';

// Using ScrollReveal's default configuration
// Vue.use(VueScrollReveal);


// OR specifying custom default options for all uses of the directive
Vue.use(VueScrollReveal, {
  class: 'v-scroll-reveal', // A CSS class applied to elements with the v-scroll-reveal directive; useful for animation overrides.
  duration: 1000,
  scale: 1,
  distance: '50px',
  mobile: true,
  delay: 0
});


const vue = new Vue({
  router,
  store,
  render: h => h(App)
})

vue.$mount('#app')
